import { TemplateEditorAction, TemplateState } from '../../../templateeditor-types';
import { setIsDirty } from '../../../updaters';
import {
  TEMPLATE_UPDATE_FIELD_ADDCHECKBOXESTOGROUP,
  TEMPLATE_UPDATE_FIELD_CHECKBOXGROUPITEMS,
  TEMPLATE_UPDATE_FIELD_GROUPCHECKBOXES,
  TEMPLATE_UPDATE_FIELD_UNGROUPCHECKBOX
} from './actionTypes';
import { createCheckboxGroup, addExistingCheckboxesToGroup, addCheckboxGroupItems, ungroupCheckboxItems } from './updaters';

export default function checkboxControlsReducer(draftState: TemplateState, action: TemplateEditorAction) {
  const { type, payload } = action;
  switch (type) {
    case TEMPLATE_UPDATE_FIELD_GROUPCHECKBOXES:
      return setIsDirty(createCheckboxGroup(draftState, payload));

    case TEMPLATE_UPDATE_FIELD_CHECKBOXGROUPITEMS:
      return setIsDirty(addCheckboxGroupItems(draftState, payload));

    case TEMPLATE_UPDATE_FIELD_UNGROUPCHECKBOX:
      return setIsDirty(ungroupCheckboxItems(draftState, payload));

    case TEMPLATE_UPDATE_FIELD_ADDCHECKBOXESTOGROUP:
      return setIsDirty(addExistingCheckboxesToGroup(draftState, payload));

    default:
      return draftState;
  }
}
